import $ from 'jquery';

export default class Accordion {
  constructor(section) {
    this.$el = $(section.el);
    this.accordionContentAttr = 'data-accordion-content';
    this.accordionTriggerAttr = 'data-accordion-trigger';
    this.accordionContent = '[data-accordion-content]';
    this.accordionTrigger = '[data-accordion-trigger]';
    this.activeAccordion = 'accordion-active';

    this._bindEvents();
  }

  _bindEvents() {
    $(this.accordionTrigger, this.$el).on('click', (event) => this._toggle(event));
  }

  _toggle(event) {
    event.preventDefault();
    const $target = $(event.currentTarget);
    const trigger = $target.attr(this.accordionTriggerAttr);
    const $content = $(`[${this.accordionContentAttr}="${trigger}"]`);

    if ($target.hasClass(this.activeAccordion)) {
      this._close($target, $content);
    } else {
      this._closeAll();
      this._open($target, $content);
    }
  }

  _closeAll() {
    $(this.accordionTrigger).each((index, accordion) => {
      const $target = $(accordion);

      if ($target.hasClass(this.activeAccordion)) {
        $target.trigger('click');
      }
    });
  }

  _open($target, $content) {
    $content.slideDown({
      start: () => $target.addClass(this.activeAccordion),
    });
  }

  _close($target, $content) {
    $content.slideUp({
      start: () => $target.removeClass(this.activeAccordion),
    });
  }

  onBlockSelect(block) {
    const $container = $(block);
    const $target = $container.find(this.accordionTrigger);

    if (!$target.hasClass(this.activeAccordion)) {
      $target.trigger('click');
    }
  }
}
